var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        {
          staticClass: "mb-18",
          attrs: {
            label: _vm.chartType == "listTable" ? "显示字段" : "维度指标设置",
          },
        },
        [
          _c("el-button", { on: { click: _vm.openDrawer } }, [
            _vm._v("点击设置"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: { visible: _vm.drawer, title: "维度指标设置", size: 360 },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticStyle: { flex: "auto", "padding-top": "10px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "default", type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.drawer = false
                            },
                          },
                        },
                        [_vm._v("关闭")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "drawer-main" }, [
            _c(
              "div",
              { ref: "formBoxRefs", staticClass: "form-box" },
              [
                _c(
                  "el-form",
                  { attrs: { "label-width": "60" } },
                  [
                    _vm.isShowDimension()
                      ? _c("el-form-item", { attrs: { label: "维度" } }, [
                          _c(
                            "div",
                            { staticClass: "input-box" },
                            [
                              _c(
                                "el-scrollbar",
                                { attrs: { "max-height": "132px" } },
                                [
                                  _c("DimensionCom", {
                                    attrs: {
                                      needSort: false,
                                      needChangeAlias: _vm.showChangeAlias,
                                      needCalcMode: false,
                                      needFormat: false,
                                      isDimension: "",
                                      chartType: _vm.chartType,
                                    },
                                    on: { onSort: _vm.onSort },
                                    model: {
                                      value: _vm.dimension,
                                      callback: function ($$v) {
                                        _vm.dimension = $$v
                                      },
                                      expression: "dimension",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDimension()
                      ? _c(
                          "el-popover",
                          {
                            ref: "sortPopoverRefs",
                            attrs: {
                              placement: "right-start",
                              width: 200,
                              trigger: "click",
                              "popper-class": "fields-popover",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "reference",
                                  fn: function () {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.dimension.length < 1,
                                              expression:
                                                "dimension.length < 1",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-circle-plus",
                                          },
                                        },
                                        [_vm._v("添加维度")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              890005360
                            ),
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fields-popover-content" },
                              _vm._l(_vm.fields, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.disabled,
                                        expression: "!item.disabled",
                                      },
                                    ],
                                    key: index,
                                    staticClass: "fields-popover-item",
                                    class: item.disabled ? "active" : "",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.addCom(
                                          item.field_name_en,
                                          "dimension"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.field_name) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.chartType == "pivotTable"
                      ? _c("el-form-item", { attrs: { label: "维度行" } }, [
                          _c(
                            "div",
                            { staticClass: "input-box" },
                            [
                              _c(
                                "el-scrollbar",
                                { attrs: { "max-height": "132px" } },
                                [
                                  _c("DimensionCom", {
                                    attrs: {
                                      isDimension: "",
                                      chartType: _vm.chartType,
                                    },
                                    on: { onSort: _vm.onSort },
                                    model: {
                                      value: _vm.dimensionRow,
                                      callback: function ($$v) {
                                        _vm.dimensionRow = $$v
                                      },
                                      expression: "dimensionRow",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-popover",
                                    {
                                      ref: "sortPopoverRefs",
                                      attrs: {
                                        placement: "right-start",
                                        width: 200,
                                        trigger: "click",
                                        "popper-class": "fields-popover",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      icon: "el-icon-circle-plus",
                                                    },
                                                  },
                                                  [_vm._v("添加维度行")]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3810324069
                                      ),
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "fields-popover-content",
                                        },
                                        _vm._l(
                                          _vm.fields,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: !item.disabled,
                                                    expression:
                                                      "!item.disabled",
                                                  },
                                                ],
                                                key: index,
                                                staticClass:
                                                  "fields-popover-item",
                                                class: item.disabled
                                                  ? "active"
                                                  : "",
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.addCom(
                                                      item.field_name_en,
                                                      "dimensionRow"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.field_name) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.chartType == "pivotTable"
                      ? _c("el-form-item", { attrs: { label: "维度列" } }, [
                          _c(
                            "div",
                            { staticClass: "input-box" },
                            [
                              _c(
                                "el-scrollbar",
                                { attrs: { "max-height": "132px" } },
                                [
                                  _c("DimensionCom", {
                                    attrs: { chartType: _vm.chartType },
                                    on: { onSort: _vm.onSort },
                                    model: {
                                      value: _vm.dimensionCol,
                                      callback: function ($$v) {
                                        _vm.dimensionCol = $$v
                                      },
                                      expression: "dimensionCol",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-popover",
                                    {
                                      ref: "sortPopoverRefs",
                                      attrs: {
                                        placement: "right-start",
                                        width: 200,
                                        trigger: "click",
                                        "popper-class": "fields-popover",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      icon: "el-icon-circle-plus",
                                                    },
                                                  },
                                                  [_vm._v("添加维度列")]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3269417470
                                      ),
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "fields-popover-content",
                                        },
                                        _vm._l(
                                          _vm.fields,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: !item.disabled,
                                                    expression:
                                                      "!item.disabled",
                                                  },
                                                ],
                                                key: index,
                                                staticClass:
                                                  "fields-popover-item",
                                                class: item.disabled
                                                  ? "active"
                                                  : "",
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.addCom(
                                                      item.field_name_en,
                                                      "dimensionCol"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.field_name) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.chartType != "listTable"
                      ? _c("el-form-item", { attrs: { label: "指标" } }, [
                          _c(
                            "div",
                            { staticClass: "input-box" },
                            [
                              _c(
                                "el-scrollbar",
                                { attrs: { "max-height": "132px" } },
                                [
                                  _c("DimensionCom", {
                                    attrs: { chartType: _vm.chartType },
                                    on: { onSort: _vm.onSort },
                                    model: {
                                      value: _vm.metrics,
                                      callback: function ($$v) {
                                        _vm.metrics = $$v
                                      },
                                      expression: "metrics",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.chartType != "listTable"
                      ? _c(
                          "el-popover",
                          {
                            ref: "sortPopoverRefs",
                            attrs: {
                              placement: "right-start",
                              width: 200,
                              trigger: "click",
                              "popper-class": "fields-popover",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "reference",
                                  fn: function () {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-circle-plus",
                                          },
                                        },
                                        [_vm._v("添加指标")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2368667323
                            ),
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fields-popover-content" },
                              _vm._l(_vm.fields, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.disabled,
                                        expression: "!item.disabled",
                                      },
                                    ],
                                    key: index,
                                    staticClass: "fields-popover-item",
                                    class: item.disabled ? "active" : "",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.addCom(
                                          item.field_name_en,
                                          "metrics"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.field_name) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.chartType == "progressbar"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "目标值" } },
                          [
                            _c("el-input-number", {
                              staticClass: "w-100",
                              attrs: { min: 0 },
                              model: {
                                value:
                                  _vm.optionModel.setDimensional.targetValue,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.optionModel.setDimensional,
                                    "targetValue",
                                    $$v
                                  )
                                },
                                expression:
                                  "optionModel.setDimensional.targetValue",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.chartType == "listTable"
                      ? _c("el-form-item", { attrs: { label: "显示字段" } }, [
                          _c(
                            "div",
                            { staticClass: "input-box" },
                            [
                              _c(
                                "el-scrollbar",
                                { attrs: { "max-height": "132px" } },
                                [
                                  _c("DimensionCom", {
                                    attrs: {
                                      needSort: false,
                                      needChangeAlias: _vm.showChangeAlias,
                                      needCalcMode: false,
                                      needFormat: false,
                                      chartType: _vm.chartType,
                                      isDimension: "",
                                    },
                                    on: { onSort: _vm.onSort },
                                    model: {
                                      value: _vm.showFields,
                                      callback: function ($$v) {
                                        _vm.showFields = $$v
                                      },
                                      expression: "showFields",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.chartType == "listTable"
                      ? _c(
                          "el-popover",
                          {
                            ref: "sortPopoverRefs",
                            attrs: {
                              placement: "right-start",
                              width: 200,
                              trigger: "click",
                              "popper-class": "fields-popover",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "reference",
                                  fn: function () {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-circle-plus",
                                          },
                                        },
                                        [_vm._v("添加显示字段")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2862871197
                            ),
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fields-popover-content" },
                              _vm._l(_vm.fields, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.disabled,
                                        expression: "!item.disabled",
                                      },
                                    ],
                                    key: index,
                                    staticClass: "fields-popover-item",
                                    class: item.disabled ? "active" : "",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.addCom(
                                          item.field_name_en,
                                          "showFields"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.field_name) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }